<template>
  <div class="client">
      <!-- hideClientName - спрятать название клиента в карточке клиента -->
      <a href="#" @click.prevent="goToClientCard(clientInfo.id)" class="title">{{clientInfo.title}}</a>
      <div class="options-block">
          <p v-if="clientInfo.city"><span>Город: </span>{{clientInfo.city}}</p>
          <p v-if="clientInfo.region"><span>Регион: </span>{{clientInfo.region}}</p>
          <p v-if="clientInfo.phone"><span>Телефон: </span>{{clientInfo.phone}}</p>
          <p class="options-block_no-capitalize" v-if="clientInfo.email"><span>email: </span>{{clientInfo.email}}</p>
      </div>
  </div>
</template>
<script>
export default {
    props: ['clientInfo'],
    data: function(){
        return {}
    },
    methods: {
        goToClientCard(id){
            this.$localStorageSet('clientCardInfo', this.clientInfo)
            this.$router.push('/clientCard/'+id)
        }
    }
}
</script>
<style lang="scss" scoped>
.client{
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    margin-bottom: 20px;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    
    .title{
        width: 100%;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        text-transform: uppercase;
        margin-bottom: 15px;
    }
    .button{
        width: 100%;
        background: green;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000000;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
        color: #fff;
    }
    .options-block{
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;
        p, span{
            font-weight: 500;
            font-size: 14px;
            text-transform: capitalize;
            color: #000000;
        }
        .options-block_no-capitalize{
            text-transform: none;
        }
    }
    .icon-block{
        height: 32px;
        display: flex;
        align-items: center;
        
        justify-content: flex-end;
        .reSend,
        .alertIcon{
            width: 32px;
            height: 32px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          
            background-color: #fff;
        }
        .alertIcon{
            background-image: url('../../img/alert.svg');
        }
        .reSend{
            background-image: url('../../img/resend.svg');
        }
    }
    .edit-block{
        width: 100%;
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .edit{
            width: 49%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #1240AB;
            color: #fff;

        }
        .delete{
            width: 49%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #D30202;
            color: #fff;
        }
    }
}

</style>